import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { NumberFormatted } from '@/modules/trade/types';

interface Props {
  percentual: NumberFormatted;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PercentualText',
  props: {
    percentual: null
  },
  setup(__props: any) {

const props = __props as {
  percentual: NumberFormatted;
};



const computedPercentualClass = computed(() => {
  return [
    'percentual-text__text--secondary',
    {
      'percentual-text__text--positive':
        props.percentual && props.percentual.value > 0,
      'percentual-text__text--negative':
        props.percentual && props.percentual.value < 0
    }
  ];
});

return { __sfc: true,props, computedPercentualClass }
}

})